import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _PressureLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M20.693 17.33a9 9 0 1 0-17.386 0" }),
            React.createElement("path", { stroke: "currentColor", d: "M12.766 15.582c.487.71.145 1.792-.766 2.417-.91.626-2.043.558-2.53-.151-.52-.756-2.314-5.007-3.403-7.637-.205-.495.4-.911.79-.542 2.064 1.96 5.39 5.157 5.909 5.913Z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M12 6v2M5.636 8.636 7.05 10.05M18.364 8.636 16.95 10.05M20.693 17.33l-1.931-.518M3.307 17.33l1.931-.518" })));
}
const PressureLight = forwardRef(_PressureLight);
export { PressureLight };
